import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Checkbox } from 'ui-components/components/checkbox/';
import { noop } from 'ui-components/default-props/noop';
import { Input } from 'ui-components/components/input';

import { BULK_UPDATE_FULFILLMENT_PLAN_ID } from '../../constants';
import { FormattedMessagePropType } from '../../../../prop-types/intl';
import style from './inputs.module.less';

const freightLabel = (
  <FormattedMessage defaultMessage='Freight Class Code' description='otherShippingOptions.freightClassLabel' id='nlYUpG' />
);

const FreightClassCode = ({ checked = false, label, onCheck = noop, optionData = '', updateOption = noop, fulfillmentPlanId = '' }) => {
  const [value, setValue] = useState(optionData);

  useEffect(() => {
    if (fulfillmentPlanId === BULK_UPDATE_FULFILLMENT_PLAN_ID) {
      setValue('');
    }
  }, [fulfillmentPlanId]);

  const onBlur = useCallback(() => {
    updateOption({ id: 'freightClassCode', value });
  }, [value, updateOption]);

  return (
    <div>
      <Checkbox checked={checked} label={label} onChange={onCheck} />
      {checked && (
        <div className={style['single-input']}>
          <Input label={freightLabel} onBlur={onBlur} onChange={setValue} value={value} />
        </div>
      )}
    </div>
  );
};

FreightClassCode.propTypes = {
  checked: PropTypes.bool,
  fulfillmentPlanId: PropTypes.string,
  label: FormattedMessagePropType.isRequired,
  onCheck: PropTypes.func,
  optionData: PropTypes.string,
  updateOption: PropTypes.func,
};

export default FreightClassCode;
